module.exports = __webpack_public_path__ + "img/reward_500.62a1b67f.png";